<template>
  <div class="declarePage2">
    <div class="declarePage2Text" v-html="TitleInfo"></div>
    <div class="he40"></div>
    <div class="linkMove">
      <div v-for="(item, index) in LinkList" :key="index">
        <span></span>
        {{ item.title }}
        <div class="fenxiang" @click="fenxiangLink(item.link)">
          <i class="el-icon-link"></i> 分享
        </div>
        <div class="fenxiang" @click="openLink(item.link)">
          打开
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSeniorTitleInfo, getApiSeniorTitleLinkList } from "@/api/api.js";

export default {
  data() {
    return {
      TitleInfo: "",
      LinkList: []
    };
  },
  mounted() {
    this.getSeniorTitleInfo();
    this.getApiSeniorTitleLinkList();
  },
  methods: {
    getSeniorTitleInfo() {
      getSeniorTitleInfo().then(res => {
        if (res.code === 0) {
          this.TitleInfo = res.data.content;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    getApiSeniorTitleLinkList() {
      getApiSeniorTitleLinkList().then(res => {
        if (res.code === 0) {
          console.log(res.data);
          this.LinkList = res.data;
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    fenxiangLink(link) {
      var Url2 = link;
      var oInput = document.createElement("input");
      oInput.value = Url2;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$message({
        message: "复制成功",
        type: "success"
      });
    },
    openLink(link) {
      // window.open()
      window.open(link, "_blank");
    }
    // societyOverview
  }
};
</script>

<style lang="less">
.declarePage2 {
  padding: 16px;
  box-sizing: border-box;
  .declarePage2Text {
    // position: relative;
    // width: 100%;
    margin-bottom: 10px;
    // padding-left: 20px;
    font-size: 16px;
    font-weight: 400;
    color: rgba(52, 52, 52, 1);
    line-height: 30px;
    box-sizing: border-box;
    // text-indent: 2em;
  }
  .linkMove {
    > div {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 10px;
        height: 10px;
        background: rgba(22, 81, 148, 1);
        border-radius: 50%;
        margin-right: 10px;
      }
      .fenxiang {
        color: rgba(22, 81, 148, 1);
        margin-left: 10px;
        font-weight: bold;
        font-size: 14px;
      }
    }
  }
  .item-img {
    text-align: center;
  }
}
</style>
